<div [formGroup]="SettingForm" class="one miscellaneous" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <h2 fxFlex="35" class="pr-1">
      <strong>Miscellaneous Settings</strong>
    </h2>
    <h3 fxFlex="65" class="pr-1">
      <strong>Do NOT change these options unless advised to do so by a support technician!</strong>
    </h3>
  </div>
  <mat-divider horizontal></mat-divider>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mt-8">
    <mat-form-field fxFlex="70" class="example pr-1" appearance="outline">
      <mat-label>Registration Key Expiry Warning (days)</mat-label>
      <input matInput />
    </mat-form-field>
    <mat-form-field fxFlex="30" class="example pr-1" appearance="outline">
      <mat-label>Password</mat-label>
      <input matInput />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <button matButton="filled" class="mat-accent m-8 pr-1" fxFlex="50">
      Restore Additional Text Position
    </button>
    <button matButton="filled" class="mat-accent m-8 pr-1" fxFlex="50" (click)="supportUtilities()">
      Support Utilities
    </button>
    <div [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"></div>
    <mat-form-field class="example-full-width" style="display: none">
      <!-- <input matInput [matDatepicker]="xerodatepicker" name="XeroStartDate" formControlName="XeroStartDate" placeholder="Choose a date">
            <mat-datepicker touchUi #xerodatepicker></mat-datepicker> -->
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="m-8">
    <mat-form-field fxFlex="70" class="example pr-1" appearance="outline">
      <mat-label>Import what data ?</mat-label>
      <mat-select>
        <mat-option>All</mat-option>
        <mat-option>Account</mat-option>
        <mat-option>Activity</mat-option>
        <mat-option>Banking</mat-option>
      </mat-select>
    </mat-form-field>
    <button matButton="filled" class="mat-accent m-8 pr-1" fxFlex="30">Import</button>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="m-8">
    <div class="example pr-1" fxFlex="50">
      <mat-checkbox>Reopen files when loading</mat-checkbox>
      <mat-checkbox>Log Debuge Info</mat-checkbox>
      <mat-checkbox>Don't Use Styles</mat-checkbox>
      <mat-checkbox>Don't Highlight Current Tab</mat-checkbox>
    </div>
    <div class="example pr-1" fxFlex="50">
      <mat-checkbox>Don't Check Trust on Statup</mat-checkbox>
      <mat-checkbox>Don't Check Practice on Statup</mat-checkbox>
      <mat-checkbox>Don't Use Data Lock</mat-checkbox>
      <mat-checkbox>Don't Use Roaming User Setting</mat-checkbox>
      <mat-checkbox>Don't Use HTTPS</mat-checkbox>
    </div>
  </div>

  <mat-menu #menu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item [matMenuTriggerFor]="cloudsync" disabled>Cloud Sync</button>
    <button mat-menu-item disabled>Fix Blank Matter Guid</button>
    <button mat-menu-item disabled>Recalc WIP GST</button>
    <button mat-menu-item [matMenuTriggerFor]="trust" disabled>Trust</button>
    <button mat-menu-item [matMenuTriggerFor]="practiceaccount" disabled>Practice Account</button>
    <button mat-menu-item disabled>Mark Item as sent to Xero</button>
    <button mat-menu-item [matMenuTriggerFor]="resendentire" disabled>
      Re-send entire table to the cloud
    </button>
    <button mat-menu-item disabled>Make Outlook Addin not check for logged in user</button>
    <button mat-menu-item (click)="xeroSartDate()">Select Xero Sart Date</button>
    <button mat-menu-item disabled>Fix Document Quote issue (SQl only)</button>
  </mat-menu>

  <mat-menu #cloudsync="matMenu">
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Show Cloud Sync Info</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Clear Cloud Sync Info</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Skip Last Sync Error</a>
  </mat-menu>

  <mat-menu #trust="matMenu">
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Recalc Trust Account Totals
    </a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Recalc Control Account Balances
    </a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Fix mislinked Trust Reversals
    </a>
    <mat-divider></mat-divider>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Release Trust Database</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Fix Trust Banking</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Create Manual Trust Entry
    </a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Fix Trust Adjustments</a>
  </mat-menu>

  <mat-menu #practiceaccount="matMenu">
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Release Draft Invoice Items
    </a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Redo Invoice Journals</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Create Receipts for Old Invoice
    </a>
    <a mat-menu-item target="_blank" href="#">Allocate Unused Credits</a>
    <a mat-menu-item target="_blank" href="#">Recalc Account Balances</a>
  </mat-menu>

  <mat-menu #resendentire="matMenu">
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Re-send Rates table</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Re-send Documents table</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">Re-send WorkItems table</a>
    <a mat-menu-item target="_blank" rel="noopener noreferrer" href="#">
      Re-send WorkItems since July 2019
    </a>
  </mat-menu>
</div>
